const GlobalFiltersActionTypes = {
  SET_PARAMETER: "filters/SET_PARAMETER",
  SET_FILTERS: "filters/SET_FILTERS",
  SET_SELECTED_FILTERS: "filters/SET_SELECTED_FILTERS",
};

export default GlobalFiltersActionTypes;
